import { create } from 'zustand';
import { MappedEventTypes } from '@src/common/types/empTypes';
import { CollapseProps } from 'antd';
import { EMetricTypes } from '@src/emp-3.0/types';

export type TToolTypes = 'livelens' | 'validation' | 'eventlooker' | 'deployment' | null;

export interface IMetricBuilderStore {
  formInstance: any;
  metricType: EMetricTypes;
  setMetricType: (metricType: EMetricTypes) => void;
  setFormInstance: (formInstance: any) => void;
  // default is section 1
  activeSectionKey: CollapseProps['activeKey'];
  setActiveSectionKey: (activeKey: CollapseProps['activeKey']) => void;
  activeTool: TToolTypes;
  setActiveTool: (activeTool: TToolTypes) => void;
  deploymentStatus: 'inprogress' | 'success' | 'failed' | null;
  setDeploymentStatus: (status: 'inprogress' | 'success' | 'failed' | null) => void;
  initialEvent: MappedEventTypes | null;
  setInitialEvent: (initialEvent: MappedEventTypes | null) => void;
  completeEvent: MappedEventTypes | null;
  setCompleteEvent: (completeEvent: MappedEventTypes | null) => void;
  withoutEvent: MappedEventTypes | null;
  setWithoutEvent: (withoutEvent: MappedEventTypes | null) => void;
  numeratorEvent: MappedEventTypes | null;
  setNumeratorEvent: (event: MappedEventTypes | null) => void;
  denominatorEvent: MappedEventTypes | null;
  setDenominatorEvent: (event: MappedEventTypes | null) => void;
  resetAll: () => void;
}
// when a section has its own draft existing, it's status will be editing

export const useMetricBuilderStore = create<IMetricBuilderStore>((set, get) => ({
  // for event looker apply as fuction
  metricType: EMetricTypes.DURATION,
  setMetricType: (metricType: EMetricTypes) => set({ metricType }),
  formInstance: null,
  setFormInstance: (formInstance) => set({ formInstance }),
  activeSectionKey: ['1'], // default is section 1
  setActiveSectionKey: (activeKey) => set({ activeSectionKey: activeKey }),
  activeTool: null,
  setActiveTool: (activeTool: TToolTypes) => set({ activeTool }),
  deploymentStatus: null,
  setDeploymentStatus: (status) => set({ deploymentStatus: status }),
  initialEvent: null,
  setInitialEvent: (initialEvent) => {
    set({ initialEvent });
  },
  completeEvent: null,
  setCompleteEvent: (completeEvent) => {
    set({ completeEvent });
  },
  withoutEvent: null,
  setWithoutEvent: (withoutEvent) => {
    set({ withoutEvent });
  },
  numeratorEvent: null,
  setNumeratorEvent: (numeratorEvent) => {
    set({ numeratorEvent });
  },
  denominatorEvent: null,
  setDenominatorEvent: (denominatorEvent) => {
    set({ denominatorEvent });
  },
  resetAll: () => {
    get().setActiveTool(null);
    get().setInitialEvent(null);
    get().setCompleteEvent(null);
    get().setWithoutEvent(null);
    get().setNumeratorEvent(null);
    get().setDenominatorEvent(null);
    get().setDeploymentStatus(null);
    get().setActiveSectionKey(['1']);
  },
}));
